import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
//import { catchError, retry } from 'rxjs/operators';
import { PostTenderData, StopData, TenderData } from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class CarrierTenderService {
    public saved: boolean = false;
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
        this.saved = false;
    }

    public getStopData(id: string) {
        return this.http.get<StopData>(this.baseUrl + 'api/CarrierTender/GetStopData/?id=' + id);
    }

    public getTenderData(id: string) {
        return this.http.get<TenderData>(this.baseUrl + 'api/CarrierTender/GetTenderData/?id=' + id);
    }

    public saveCarrierTender(tenderData: PostTenderData) {
        return this.http.post<string>(this.baseUrl + 'api/CarrierTender/SaveTenderData', tenderData, httpOptions);
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(
            'Something bad happened; please try again later.');
    };
}